import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Users, Heart, User, Shield, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const TopBar = ({ title }) => (
  <header className="mm-sticky-header sticky top-0 z-30">
    <div className="max-w-md mx-auto px-5 py-4 flex items-center justify-between">
      <div>
        <div className="overline" data-testid="brand-name">Muslim Mingle</div>
        {title && <div className="font-serif-display text-2xl mt-1" data-testid="page-title">{title}</div>}
      </div>
    </div>
  </header>
);

const BottomNav = () => {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  if (!user) return null;
  const items = [
    { to: "/attendees", icon: Users, label: "Attendees", id: "nav-attendees" },
    { to: "/matches", icon: Heart, label: "Matches", id: "nav-matches" },
    { to: "/profile", icon: User, label: "Profile", id: "nav-profile" },
  ];
  if (user.is_admin) items.push({ to: "/admin", icon: Shield, label: "Admin", id: "nav-admin" });

  const onLogout = () => {
    logout();
    nav("/login");
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-30 mm-sticky-header" data-testid="bottom-nav">
      <div
        className="max-w-md mx-auto flex justify-around items-stretch px-2 py-2"
        style={{ paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 48px)" }}
      >
        {items.map((item) => {
          const active = loc.pathname.startsWith(item.to);
          const Icon = item.icon;
          return (
            <Link
              key={item.to}
              to={item.to}
              data-testid={item.id}
              className={`flex flex-col items-center gap-1 py-2 flex-1 transition-opacity ${active ? "opacity-100" : "opacity-50 hover:opacity-80"}`}
            >
              <Icon size={18} strokeWidth={1.5} color="#0F172A" />
              <span className="text-[10px] tracking-widest uppercase font-semibold" style={{ color: "#0F172A" }}>
                {item.label}
              </span>
            </Link>
          );
        })}
        <button
          onClick={onLogout}
          data-testid="nav-logout"
          className="flex flex-col items-center gap-1 py-2 flex-1 opacity-50 hover:opacity-80 transition-opacity"
        >
          <LogOut size={18} strokeWidth={1.5} color="#0F172A" />
          <span className="text-[10px] tracking-widest uppercase font-semibold" style={{ color: "#0F172A" }}>
            Logout
          </span>
        </button>
      </div>
    </nav>
  );
};

const Shell = ({ title, children, hideBottom = false }) => (
  <div className="min-h-screen pb-40">
    <TopBar title={title} />
    <main className="max-w-md mx-auto px-5 py-6 mm-fade-in">{children}</main>
    {!hideBottom && <BottomNav />}
  </div>
);

export default Shell;
